import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
  TimePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { TextField } from "@material-ui/core";
import dayjs from "dayjs";

const getCurrentTimeString = (time) => {
  const hours = time.format('HH');
  const minutes = time.format('mm');
  return `${hours}:${minutes}`;
};

const getDateTime=(time)=>{
  const [hours, minutes] = time.split(":").map(Number);

  // Set hours and minutes
  return dayjs().hour(hours).minute(minutes).second(0).millisecond(0);
}

export const MyTimePicker = ({
  label,
  value,
  error,
  required,
  onChange,
  ...rest
}) => {

return   <TextField
label={label}
type="time"
value={getCurrentTimeString(dayjs(value))}
onChange={(e)=>e.target.value? onChange(getDateTime(e.target.value)):null}

InputLabelProps={{
  shrink: true,
}}
inputProps={{
  step: 60, // 1 min step
  lang: 'en-GB',
}}
fullWidth
variant="outlined"
{...rest}
/>
  // return (
    
  //   <MuiPickersUtilsProvider utils={DateFnsUtils}>
  //     <KeyboardTimePicker
  //       fullWidth
  //       // disableToolbar
  //       showToolbar
  //       variant="inline"
  //       size="small"
  //       label={label}
  //       value={value}
  //       onChange={onChange}
  //       KeyboardButtonProps={{
  //         "aria-label": label,
  //       }}
  //       InputLabelProps={{
  //         shrink: true,
  //       }}
  //       required={required}
  //       error={error}
  //       {...rest}
  //     />
  //   </MuiPickersUtilsProvider>
  // );
};
